import { useState } from 'react';

export type UseSpotlightReturn = {
  focus: (index: number) => void;
  clear: () => void;
  clearIfMatches: (index: number) => void;
  isFocused: (index: number) => boolean;
};

export function useSpotlight(): UseSpotlightReturn {
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);

  const focus = (index: number) => setFocusedIndex(index);
  const clear = () => setFocusedIndex(null);
  const clearIfMatches = (index: number) => {
    if (focusedIndex === index) setFocusedIndex(null);
  };
  const isFocused = (index: number) => index === focusedIndex;

  return { focus, clear, clearIfMatches, isFocused };
}
